import { render, staticRenderFns } from "./requestList.vue?vue&type=template&id=f21809dc&scoped=true&"
import script from "./requestList.vue?vue&type=script&lang=js&"
export * from "./requestList.vue?vue&type=script&lang=js&"
import style0 from "./requestList.vue?vue&type=style&index=0&id=f21809dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21809dc",
  null
  
)

export default component.exports